module.exports = __webpack_public_path__ + "img/default-avatar.a5369809.webp";